import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff, LogIn } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ username: "", password: "", remember: false });
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try { await login(f.username, f.password, f.remember); nav("/dashboard"); } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen relative grain flex flex-col items-center justify-center px-4 py-10" style={{ background: "linear-gradient(135deg,#022c22 0%,#065f46 45%,#0f766e 100%)" }}>
      <div className="relative z-10 flex flex-col items-center text-center stagger">
        <div className="h-28 w-28 rounded-full bg-white shadow-2xl shadow-emerald-950/40 flex items-center justify-center p-2 ring-4 ring-white/20">
          <img src="/logo.webp" alt="Logo Yayasan" className="h-full w-full object-contain rounded-full" />
        </div>
        <h1 className="mt-5 text-3xl sm:text-4xl font-extrabold text-white tracking-tight">Portal Inklusi</h1>
        <p className="text-emerald-100/90 text-sm sm:text-base mt-1">Yayasan Bintang Pelita Nusa</p>
      </div>
      <form onSubmit={submit} data-testid="login-form" className="relative z-10 mt-8 w-full max-w-md bg-white rounded-2xl shadow-2xl shadow-emerald-950/40 p-8 sm:p-10 page-enter">
        <h2 className="text-2xl font-extrabold text-slate-900 text-center">Login</h2>
        <p className="text-sm text-slate-500 text-center mt-1 mb-6">Masuk dengan akun Anda</p>
        {err && <div data-testid="login-error" className="mb-4 rounded-lg bg-rose-50 border border-rose-200 text-rose-700 text-sm px-3 py-2">{err}</div>}
        <label className="label">Username</label>
        <input data-testid="login-username-input" className="input mb-4" placeholder="username" value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} autoFocus required />
        <label className="label">Password</label>
        <div className="relative mb-4">
          <input data-testid="login-password-input" type={show ? "text" : "password"} className="input pr-10" placeholder="••••••••" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required />
          <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-2.5 text-slate-400 hover:text-slate-600" data-testid="login-toggle-password">{show ? <EyeOff size={16} /> : <Eye size={16} />}</button>
        </div>
        <label className="flex items-center gap-2 text-sm text-slate-600 mb-5"><input type="checkbox" data-testid="login-remember-checkbox" className="accent-emerald-600" checked={f.remember} onChange={(e) => setF({ ...f, remember: e.target.checked })} /> Ingat saya</label>
        <button data-testid="login-submit-button" className="btn-primary w-full py-2.5 text-base" disabled={busy}><LogIn size={18} /> {busy ? "Memproses..." : "Login"}</button>
        <p className="text-xs text-slate-500 text-center mt-6 leading-relaxed">Aplikasi ini untuk <b>Admin, Koordinator, Guru Pendamping</b> dan <b>Orangtua siswa pendampingan inklusi</b>.<br />Silakan hubungi <b>Admin</b> untuk permintaan login.</p>
      </form>
      <p className="relative z-10 text-xs text-emerald-100/70 mt-6">© {new Date().getFullYear()} <b>Portal Pendampingan Inklusi</b>. All rights reserved.</p>
    </div>
  );
}
